import Vue from 'vue';
import VueSimpleSpinner from 'vue-simple-spinner';
import HttpMixin from '@/mixins/HttpMixin';

export default Vue.component('recently-marked-paid', {
  name: 'RecentlyMarkedPaid',
  components: {
    VueSimpleSpinner,
  },
  mixins: [ HttpMixin ],
  data() {
    return {
      cardExpanded: false,
      loadingInitialData: false,
      providers: []
    };
  },
  computed: {
    paidCounter (): number {
      return this.$store.state.invoices.recentlyPaidCounter;
    },
    canExport (): boolean {
      return !this.providers.some((prov: any) => Boolean(prov.isMissingFinancialInfo));
    }
  },
  watch: {
    async paidCounter () {
      if (this.cardExpanded) {
        await this.fetch();
      }
    }
  },
  created () {
    this.expandCard();
  },
  methods: {
    async expandCard() {
      this.cardExpanded = !this.cardExpanded;
      if (this.cardExpanded) {
        await this.fetch();
      }
    },
    async fetch () {
      this.providers = await (this as any).httpGet('/provider-payments/recent-paid', 'An error occurred retrieving Recently Paid Providers.');
    },
    async manuallyPay(invoiceId: number, providerId: number) {
      const body = {
        invoiceId: invoiceId,
        providerId: providerId
      };
      await (this as any).httpPut('/provider-payments/recent-paid', 'An error occurred marking Provider paid.', body);
      this.providers = this.providers.filter((prov: any) => prov.invoiceId !== invoiceId || prov.providerId !== providerId);
      if (this.providers.length === 0) {
        this.$store.commit('invoices/queueToReady');
      }
    },
    async exportCsv () {
      const data = await (this as any).httpPost('/provider-payments/csvs', 'An error occurred marking Provider paid.', false);
      await this.fetch();
      if (data) {
        this.$store.commit('invoices/updateCsvCounter');
      }
      if (this.providers.length === 0) {
        this.$store.commit('invoices/queueToReady');
      }
    },
    browseToProvider (providerId: number) {
      window.open("/providers/" + providerId, '_blank');
    }
  }
});



// WEBPACK FOOTER //
// ./src/components/payments/cards/recentlyPaid/RecentlyMarkedPaid.ts